import React, { FC, PropsWithChildren } from 'react';
import { mainDateFormat } from '@core/utils/methods';
import { RODate } from '../models';

export const ReadOnlyDate: FC<RODate> = ({
  date,
  utc = false,
}: PropsWithChildren<RODate>) => <>{mainDateFormat(date, utc)}</>;
